import { IUser } from './Iuser';
import { userProperties } from './mapperConfig';
import { UtilityService } from '../../../infrastructure/services/utils';
/**
 * provide transformation functionality for user information data using mapper configuration
 * @param   {Object} userItem transformed object
 */
export class UserMapper {
  user: IUser = {};

  constructor(userProperty: []=[]) {
    this.user = UtilityService.getMappedUserProperties(
      userProperty,
      userProperties,
      this.user
    );
  }
}